/* PROTOWORX — fitment selector

   This script NEVER builds the product grid. Liquid already rendered every card
   server-side. All this does is toggle [hidden] and add a "fits" class, which
   keeps every product link crawlable and keeps the page usable with JS off.

   WHY EVERYTHING IS RE-QUERIED RATHER THAN CACHED
   The selector and the product grid live in two different sections. Shopify's
   theme editor replaces a section's markup in place and does NOT re-run page
   scripts, so anything captured in a closure at first load goes stale the moment
   either section is edited — which showed up as the Year / Make / Model menus
   going permanently empty while editing. Elements are therefore looked up at
   call time, and init() re-runs on shopify:section:load. The form carries a
   data-pw-bound flag so re-running cannot double-bind its listeners. */
(function () {
  'use strict';

  var STORE_KEY = 'pw-ride';

  var uniq = function (a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }); };
  var byText = function (a, b) { return String(a).localeCompare(String(b), undefined, { numeric: true }); };

  function vehicles() {
    var el = document.getElementById('pw-vehicle-data');
    if (!el) return [];
    try { return (JSON.parse(el.textContent) || {}).vehicles || []; }
    catch (e) { return []; }
  }

  function cards()  { return Array.prototype.slice.call(document.querySelectorAll('[data-pw-card]')); }
  function groups() { return Array.prototype.slice.call(document.querySelectorAll('[data-pw-group]')); }
  function el(sel)  { return document.querySelector(sel); }

  function fill(sel, values, placeholder) {
    if (!sel) return;
    sel.innerHTML = '';
    sel.appendChild(new Option(placeholder, ''));
    values.forEach(function (v) { sel.appendChild(new Option(v, v)); });
  }

  function apply(y, mk, md, scroll) {
    var ride = y + ' ' + mk + ' ' + md;
    var key = y + '|' + mk + '|' + md;
    var fitCount = 0, universalCount = 0;

    cards().forEach(function (card) {
      var universal = card.dataset.universal === 'true';
      var list = (card.dataset.fits || '').split(',').map(function (s) { return s.trim(); });
      var fits = list.indexOf(key) !== -1;

      card.classList.toggle('is-fit', fits);
      card.hidden = !(fits || universal);

      if (fits) fitCount++;
      else if (universal) universalCount++;
    });

    groups().forEach(function (g) {
      g.hidden = !g.querySelector('[data-pw-card]:not([hidden])');
    });

    var bar = el('[data-pw-bar]'),
        barRide = el('[data-pw-bar-ride]'),
        barCount = el('[data-pw-bar-count]'),
        headingEl = el('[data-pw-heading]'),
        emptyEl = el('[data-pw-empty]'),
        emptyRide = el('[data-pw-empty-ride]');

    if (bar) bar.classList.add('is-active');
    if (barRide) barRide.textContent = ride;
    if (barCount) {
      barCount.textContent = fitCount
        ? fitCount + ' part' + (fitCount === 1 ? '' : 's') + ' built for this vehicle'
          + (universalCount ? ' · ' + universalCount + ' fit any vehicle' : '')
        : 'No vehicle-specific parts yet'
          + (universalCount ? ' · ' + universalCount + ' still fit' : '');
    }
    if (headingEl) {
      if (!headingEl.dataset.pwDefault) headingEl.dataset.pwDefault = headingEl.textContent;
      headingEl.textContent = fitCount ? 'Parts for your ' + md : 'Nothing for your ' + md + ' — yet';
    }
    if (emptyEl) emptyEl.classList.toggle('is-active', fitCount === 0);
    if (emptyRide) emptyRide.textContent = ride;

    try { localStorage.setItem(STORE_KEY, key); } catch (err) {}

    if (scroll) {
      var shop = document.getElementById('pw-shop');
      if (shop) shop.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function reset() {
    cards().forEach(function (c) { c.hidden = false; c.classList.remove('is-fit'); });
    groups().forEach(function (g) { g.hidden = false; });

    var bar = el('[data-pw-bar]'), emptyEl = el('[data-pw-empty]'), headingEl = el('[data-pw-heading]');
    if (bar) bar.classList.remove('is-active');
    if (emptyEl) emptyEl.classList.remove('is-active');
    if (headingEl && headingEl.dataset.pwDefault) headingEl.textContent = headingEl.dataset.pwDefault;

    var form = el('[data-pw-fit]');
    if (form) {
      var yearEl = form.querySelector('[data-pw-year]'),
          makeEl = form.querySelector('[data-pw-make]'),
          modelEl = form.querySelector('[data-pw-model]'),
          goEl = form.querySelector('[data-pw-go]');
      if (yearEl) yearEl.value = '';
      fill(makeEl, [], 'Make');
      fill(modelEl, [], 'Model');
      if (makeEl) makeEl.disabled = true;
      if (modelEl) modelEl.disabled = true;
      if (goEl) goEl.disabled = true;
    }
    try { localStorage.removeItem(STORE_KEY); } catch (err) {}
  }

  function init() {
    var VEHICLES = vehicles();
    var form = el('[data-pw-fit]');
    if (!form || !VEHICLES.length) return;

    var yearEl  = form.querySelector('[data-pw-year]');
    var makeEl  = form.querySelector('[data-pw-make]');
    var modelEl = form.querySelector('[data-pw-model]');
    var goEl    = form.querySelector('[data-pw-go]');
    if (!yearEl || !makeEl || !modelEl || !goEl) return;

    /* Always repopulate — a freshly rendered section arrives with empty menus
       even though the script itself is still loaded. */
    fill(yearEl, uniq(VEHICLES.map(function (v) { return v.y; })).sort(byText).reverse(), 'Year');
    fill(makeEl, [], 'Make');
    fill(modelEl, [], 'Model');
    makeEl.disabled = true;
    modelEl.disabled = true;
    goEl.disabled = true;

    function gate() {
      goEl.disabled = !(yearEl.value && makeEl.value && modelEl.value);
    }

    if (form.dataset.pwBound !== '1') {
      form.dataset.pwBound = '1';

      yearEl.addEventListener('change', function () {
        var makes = uniq(vehicles().filter(function (v) { return v.y === yearEl.value; })
                                   .map(function (v) { return v.mk; })).sort(byText);
        fill(makeEl, makes, 'Make');
        fill(modelEl, [], 'Model');
        makeEl.disabled = !yearEl.value;
        modelEl.disabled = true;
        gate();
      });

      makeEl.addEventListener('change', function () {
        var models = uniq(vehicles().filter(function (v) {
          return v.y === yearEl.value && v.mk === makeEl.value;
        }).map(function (v) { return v.md; })).sort(byText);
        fill(modelEl, models, 'Model');
        modelEl.disabled = !makeEl.value;
        gate();
      });

      modelEl.addEventListener('change', gate);

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        apply(yearEl.value, makeEl.value, modelEl.value, true);
      });
    }

    var resetEl = el('[data-pw-reset]');
    if (resetEl && resetEl.dataset.pwBound !== '1') {
      resetEl.dataset.pwBound = '1';
      resetEl.addEventListener('click', reset);
    }

    /* Restore a previously chosen vehicle. */
    try {
      var saved = localStorage.getItem(STORE_KEY);
      if (saved) {
        var p = saved.split('|');
        if (p.length === 3 && VEHICLES.some(function (v) { return v.y === p[0] && v.mk === p[1] && v.md === p[2]; })) {
          yearEl.value = p[0];
          yearEl.dispatchEvent(new Event('change'));
          makeEl.value = p[1];
          makeEl.dispatchEvent(new Event('change'));
          modelEl.value = p[2];
          gate();
          apply(p[0], p[1], p[2], false);
        }
      }
    } catch (err) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: fires whenever a section is re-rendered. */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { /* nothing cached to clear */ });
})();
